import React from 'react';
export function Footer() {
  return <footer className="py-10 px-4 sm:px-6 bg-brand-navy-dark text-center text-white/50 text-[10px] sm:text-xs border-t border-white/5" data-id="element-73">
      <p className="leading-relaxed max-w-2xl mx-auto font-medium mb-6" data-id="element-74">
        © 2026 Psychologist Pro™ — All Rights Reserved.
        <br data-id="element-75" />
        <br data-id="element-76" />
        The information provided on this website is intended for educational
        purposes only and is designed as a professional resource for licensed
        psychologists and therapists. It is not intended to replace independent
        clinical judgment or local ethical standards. Always use your
        professional expertise when treating patients.
      </p>
      <div className="flex justify-center gap-4 sm:gap-6 font-bold tracking-widest uppercase" data-id="element-77">
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-78">
          Terms &amp; Conditions
        </a>
        <span className="text-white/20" data-id="element-79">·</span>
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-80">
          Privacy Policy
        </a>
        <span className="text-white/20" data-id="element-81">·</span>
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-82">
          Contact
        </a>
      </div>
    </footer>;
}